import React from "react";
import {
  Layout,
  Card,
  FormLayout,
  TextField,
  InlineCode,
  Text,
} from "@shopify/polaris";
import { useTranslation } from "react-i18next";
import formatKey from "../../../../../utilities/formatKey";

export default function ThemeSettingsGUI(props) {
  const { t } = useTranslation();
  const { settingsSchema, updateSettingsSchemaField } = props;
  return (
    <Layout>
      {Object.keys(settingsSchema).map((categoryKey) => {
        const categoryContent = settingsSchema[categoryKey];
        return (
          <Layout.AnnotatedSection
            title={t(`themes.settings.categories.${categoryKey}`, formatKey(categoryKey))}
            key={categoryKey}
            description={
              <Text>
                {t("themes.settings.accessSettings", { 
                  category: t(`themes.settings.categories.${categoryKey}`, formatKey(categoryKey)).toLowerCase(),
                  code: `theme_settings.${categoryKey}`
                })}
                <Text as="span"><InlineCode>{`theme_settings.${categoryKey}`}</InlineCode></Text>
              </Text>
            }
          >
            <Card sectioned>
              <FormLayout>
                {Object.keys(categoryContent).map((fieldKey) => (
                  <TextField
                    key={fieldKey}
                    label={t(`themes.settings.fields.${fieldKey}`, formatKey(fieldKey))}
                    value={settingsSchema[categoryKey][fieldKey]}
                    onChange={(value) =>
                      updateSettingsSchemaField(value, categoryKey, fieldKey)
                    }
                    autoComplete="off"
                  />
                ))}
              </FormLayout>
            </Card>
          </Layout.AnnotatedSection>
        );
      })}
    </Layout>
  );
}
